import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalController, PopoverController, ToastController } from '@ionic/angular';
import { AdressPopoverComponent } from 'src/app/components/shared/modals/adress-popover/adress-popover.component';
import { EUserType } from 'src/app/micro-services/user/enum/e-user-type';
import { UserCoach } from 'src/app/micro-services/user/models/user-coach';
import { Address } from 'src/app/models/address';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { FromAddressComponent } from '../../address/form-address/from-address.component';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/micro-services/user/models/user';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss'],
})
export class InformationComponent implements OnInit {

  @Input() coach: UserCoach;
  coachForm: FormGroup;

  constructor(
    private readonly modalCtrl        : ModalController,
    private readonly apiProvider      : ApiProviderService,
    private readonly toastController  :  ToastController,
    private builder                   : FormBuilder,
    public popoverController          : PopoverController,
    private readonly userService      : UserService,
  ) { }

  ngOnInit() {

    this.setForm(this.coach);

  }

  setForm(coach: UserCoach) {
    this.coachForm = this.builder.group(
      {
        name: new FormControl(coach.name ? coach.name : ""),
        firstname: new FormControl(coach.firstName ? coach.firstName : ""),
        compagnyNumber: new FormControl(coach.compagnyNumber ? coach.compagnyNumber : ""),
        email: new FormControl(coach.email ? coach.email : "", Validators.required),
        phoneNumber: new FormControl(coach.phoneNumber ? coach.phoneNumber : "")
      }
    );
  }

  validate() {

    if (this.coachForm.valid) {
      this.apiProvider.editCoach({ ... this.coachForm.value, discriminator: EUserType.Coach, id: this.coach.id, Address : this.coach.address }).subscribe(
        (data : User) => {
          return this.modalCtrl.dismiss(data, 'confirm');
        },
        async (err) => {
          const toast = await this.toastController.create({
            message: "Erreur lors de l'edition",
            duration: 5000,
            buttons: [
              {
                text: 'Compris',
                role: 'cancel'
              }
            ]
          });
          await toast.present();
        }
      );
    }

  }

  backClick() {
    this.modalCtrl.dismiss();
  }

  async openPopOverAddress(e: Event, address: Address) {
    const popover = await this.popoverController.create({
      component: AdressPopoverComponent,
      event: e,
    });

    if(this.coach?.address){
      popover.componentProps = {
        address : this.coach?.address
      }
    }

    await popover.present();

    const { data, role } = await popover.onDidDismiss();

    if(role == "delete"){
      this.deleteAddress();
      return 
    }
    if(data){
      this.coach.address = data;
    }
  }

  async AddAddress() {
    let modal = await this.modalCtrl.create({
      component: FromAddressComponent,
      componentProps: {
        address : this.coach?.address,
        returnMode: true
      }
    });

    modal.present();

    const { data } = await modal.onDidDismiss();

    if(data){
      this.coach.address = data;
    }
  }

  private deleteAddress(){

    this.coach.address = null;
    this.apiProvider.editCoach( this.coach ).subscribe(
      (data : User) => {
        return this.modalCtrl.dismiss(data, 'confirm');
      },
      async (err) => {
        const toast = await this.toastController.create({
          message: "Erreur lors de l'edition",
          duration: 5000,
          buttons: [
            {
              text: 'Compris',
              role: 'cancel'
            }
          ]
        });
        await toast.present();
      }
    );
  }

}
